<template>
  <div :class="computedClass">
    <div class="mb-4">
      <span class="font-bold">Processamento Manual</span>
      <div class="flex flex-row gap-4">
        <v-select
          v-model="action"
          :options="actions"
          label="label"
          value="value"
          placeholder="Selecionar Ação"
          :reduce="(item) => item.value"
          style="width: 400px"
        ></v-select>
        <div class="flex flex-row gap-4">
          <flat-pickr
            v-show="action === STAR_MANUAL_ACTIONS.CANCEL.value"
            class="input-data-cancelamento w-full sm:mb-0 mb-3"
            name="Data de cancelamento"
            id="Data de cancelamento"
            data-testid="cancelation-date"
            v-model="cancellationDate"
            style="width: 200px"
            :config="getConfigDatePicker()"
            placeholder="Data de cancelamento"
          />
        </div>
        <vs-button
          color="primary"
          type="border"
          :disabled="
            !action ||
            (action === STAR_MANUAL_ACTIONS.CANCEL.value && !cancellationDate)
          "
          @click="execute"
          class="font-bold"
          >Executar</vs-button
        >
        <vs-button
          icon="refresh"
          @click="reloadData"
          color="primary"
          type="border"
        />
      </div>
    </div>
    <div v-for="(item, index) in logs" :key="index">
      <div class="flex flex-row gap-4 justify-start">
        <div class="flex flex-col w-1/4">
          <span class="font-bold">Tipo: </span>
          <span>{{ defineAcao(item.action) }}</span>
        </div>
        <div class="flex flex-col w-1/4">
          <span class="font-bold">Data de sincronização: </span>
          <span>{{ functions.formatDateAndHour(item.syncDate) }}</span>
        </div>
        <div class="flex flex-col w-1/6">
          <span class="font-bold">Tentativas: </span>
          <span>{{ item.tries }} </span>
        </div>
        <div class="flex flex-col w-1/4">
          <span class="font-bold">Data do Cancelamento: </span>
          <span>{{
            item.cancellationDate
              ? functions.formataDataMomentJS(
                  item.cancellationDate,
                  'DD/MM/YYYY',
                  3,
                )
              : 'Não se aplica'
          }}</span>
        </div>
        <div class="flex flex-col w-48">
          <span class="font-bold">Status: </span>
          <vs-chip class="mr-3" :color="defineCorChip(item.status)">
            {{ defineStatus(item.status) }}
          </vs-chip>
        </div>
        <div class="flex flex-col w-1/4">
          <span class="font-bold">Usuário: </span>
          <span>{{ formatResponsavel(item) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="font-bold">Arquivo: </span>
          <vs-button
            radius
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-download"
            @click="downloadFile(item.url)"
          ></vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import starApiService from '../../../../services/star.api';
import { STAR_MANUAL_ACTIONS, TIPOS_APOLICES } from '@/utils/constants';
import flatPickr from 'vue-flatpickr-component';
import moment from 'moment';
import fileDownload from '../../../../utils/fileDownload';
import { formatResponsavel } from '../../../../utils/integrationHelpers';

export default {
  name: 'StarIntegrationContent',
  components: {
    vSelect,
    flatPickr,
  },
  props: ['logs', 'policy-id', 'policyType'],
  computed: {
    STAR_MANUAL_ACTIONS() {
      return STAR_MANUAL_ACTIONS;
    },
    computedClass() {
      const hasLogs = Array.isArray(this.logs) && this.logs.length === 0;
      return hasLogs ? 'pb-24' : 'pb-8';
    },
    actions() {
      if (this.policyType !== TIPOS_APOLICES.MICRO_VIDA) {
        return [STAR_MANUAL_ACTIONS.CREATE];
      }
      return [STAR_MANUAL_ACTIONS.CREATE, STAR_MANUAL_ACTIONS.CANCEL];
    },
  },
  data() {
    return {
      functions,
      action: null,
      cancellationDate: null,
    };
  },
  mounted() {},
  methods: {
    formatResponsavel,
    defineStatus(status) {
      const colorsByStatus = {
        pending: 'Pendente',
        failed: 'Falha',
        done: 'Sincronizada',
      };
      return colorsByStatus[status];
    },
    defineCorChip(status) {
      const colorsByStatus = {
        pending: 'warning',
        failed: 'danger',
        done: 'success',
      };
      return colorsByStatus[status];
    },
    defineAcao(action) {
      const labelByAction = {
        create: 'Envio',
        down: 'Baixa',
        cancel: 'Cancelamento',
      };
      return labelByAction[action];
    },
    async execute() {
      this.$vs.loading();
      const payload = {
        policyId: this.policyId,
        action: this.action,
        cancellationDate: moment(this.cancellationDate, 'DD/MM/YYYY').toDate(),
      };

      try {
        await starApiService.execute(payload);
        notify.notifySuccess(this.$vs, 'Registro processado com sucesso.');
        this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao processar registro.');
      } finally {
        this.$vs.loading.close();
      }
    },
    async downloadFile(link) {
      fileDownload.download(window, link);
    },
    reloadData() {
      this.$emit('reload');
    },
    getConfigDatePicker() {
      return {
        ...functions.getConfigDateTimePickerDay(),
        maxDate: new Date(),
      };
    },
  },
};
</script>
